import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { userLogout } from "../../redux/reducers/user";
import { RootState, AppDispatch } from "../../redux/store";
import PROFILE_MENU_ITEMS from "../../config/profile-menu-items";

const ProfileMenu: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const username = useSelector(
    (state: RootState) => state.user.userData?.user_name
  );

  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMenuClick = (menuTitle?: string) => {
    if (menuTitle === "Logout") {
      dispatch(userLogout());
    }
    setOpen(false);
  };

  return (
    <div className="dropdown b-dropdown btn-group" ref={ref}>
      <button
        aria-haspopup="menu"
        aria-expanded={open}
        type="button"
        className="btn dropdown-toggle btn-black header-item"
        onClick={() => setOpen(!open)}
      >
        <span className="ml-1">{username}</span>{" "}
        <i className="fa fa-caret-down"/>
      </button>
      {open && (
        <ul role="menu" className="dropdown-menu show">
          {PROFILE_MENU_ITEMS.map((menu) => (
            <li key={menu.id}>
              {menu.title === "Logout" ? (
                <a
                  href="#"
                  className="dropdown-item"
                  onClick={() => handleMenuClick(menu.title)}
                >
                  {menu.title}
                </a>
              ) : (
                <Link
                  to={menu.link}
                  className="dropdown-item"
                  onClick={() => handleMenuClick(menu.title)}
                >
                  {menu.title}
                </Link>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ProfileMenu;
